var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bet-slip-fb",attrs:{"id":"bet-slip-fb"}},[_c('span',{staticStyle:{"font-size":"11pt","margin-top":"12px","margin-right":"10px","color":"white"}},[_vm._v(_vm._s(_vm.$t('bet-slip.fast-bet')))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-251c8959","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/bet-slip/BetSlipFb.vue
// module id = null
// module chunks = 